import React from 'react'
import {Row, Col, InlineLoader} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'

import DynamicEntriesTable, {DynamicEntry} from '../../../../component/dynamic-entries-table'
import SummaryPageFooter from '../../components/summary-page-footer'
import {SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS} from '../../../../constants/sections'
import {FormContentWrapper} from '../../../../ui/form'
import {StyledImg, ImageContainer} from '../../../summary-page-image/styles'
import {StyledParagraph} from '../../../../ui/styles'
import SummaryPageHeader from '../../components/summary-page-header'

const tableHeadlines = ['accountHolder', 'accountNumber']

/** One row of the direct debit account summary table. */
type DirectDebitAccountSummaryEntry = DynamicEntry & {
  route: string
  accountHolder: string
  accountNumber: string
}

export type DirectDebitAccountSummaryPageProps = {
  isLoading: boolean
  bankAccountSummary: DirectDebitAccountSummaryEntry[]
  isReadonly: boolean
  createBankAccount: () => void
}

const DirectDebitAccountSummaryPage: React.FC<DirectDebitAccountSummaryPageProps> = ({
  isLoading,
  bankAccountSummary,
  isReadonly,
  createBankAccount,
}) => {
  const {t} = useTranslation('charon')

  return (
    <>
      <FormContentWrapper>
        <SummaryPageHeader
          ctaText={t(`sub-section-menu.${SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS}.create`)}
          onCreate={createBankAccount}
          isDisabled={isReadonly}
        />
        {isLoading && (
          <Row>
            <Col>
              <InlineLoader />
            </Col>
          </Row>
        )}
        {!isLoading && bankAccountSummary.length < 1 && (
          <>
            <Row justifyContent="center">
              <Col auto>
                <ImageContainer>
                  <StyledImg src="/assets/images/no-results-dynamic-entries.png" alt="no-results" />
                </ImageContainer>
              </Col>
            </Row>
            <Row justifyContent="center">
              <Col auto>
                <StyledParagraph textAlign="center">
                  {t('direct-debit-account-summary-page.no-results.message')}
                </StyledParagraph>
              </Col>
            </Row>
          </>
        )}
        {!isLoading && bankAccountSummary.length > 0 && (
          <Row mb={40}>
            <Col>
              <DynamicEntriesTable
                dataList={bankAccountSummary || []}
                headlines={tableHeadlines}
                transPrefix="direct-debit-summary-page"
              />
            </Col>
          </Row>
        )}
      </FormContentWrapper>
      <SummaryPageFooter sectionName={SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS} />
    </>
  )
}

export default DirectDebitAccountSummaryPage
